import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=725bbf2d&"
import script from "./Deals.vue?vue&type=script&lang=ts&"
export * from "./Deals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports